import * as React from 'react';
import type { NotebookStoryCard } from '@org/model';
import type { StoryCardComponentProps } from './story-types';
import { pickLocalized, renderStoryMarkup, storyLangAttr, StoryCardHeading, StoryVocabRow } from './story-utils';

/**
 * Notebook card: a page "from her notebook" — her own words in the original
 * language on ruled paper, the source, and (when the viewer reads in the other
 * language) a simple gloss.
 */
export function StoryNotebookCard({ card, ctx }: StoryCardComponentProps<NotebookStoryCard>) {
  const date = pickLocalized(card.date, ctx.lang);
  const source = pickLocalized(card.source, ctx.lang);
  const gloss = ctx.lang !== card.originalLang ? pickLocalized(card.gloss, ctx.lang) : null;
  return (
    <div className="zs-pg-in" data-testid="story-card-notebook">
      <StoryCardHeading card={card} lang={ctx.lang} />
      <div className="zs-nb-wrap">
        <div className="zs-tp" aria-hidden="true" />
        <div className="zs-nb-page" lang={storyLangAttr(card.originalLang)}>
          {date.text ? (
            <div className="zs-dt" lang={storyLangAttr(date.lang)}>
              {date.text}
            </div>
          ) : null}
          <p>{card.original}</p>
        </div>
      </div>
      <div className="zs-nb-src">
        {ctx.labels.notebookCaption}
        {source.text ? <span lang={storyLangAttr(source.lang)}> — {source.text}</span> : null}
      </div>
      {gloss?.text ? (
        <p className="zs-gloss" lang={storyLangAttr(gloss.lang)} data-testid="story-notebook-gloss">
          {renderStoryMarkup(gloss.text)}
        </p>
      ) : null}
      <div className="zs-foot">
        <StoryVocabRow vocab={card.vocab} lang={ctx.lang} />
      </div>
    </div>
  );
}
